import { apiClient } from '../services/apiClient'
import { getAccessToken } from './getAccessToken'

export async function getUserPermissionsAsync () {
  const accessToken = await getAccessToken()

  if (!accessToken) {
    return null
  }

  return apiClient.getAsync('/api/me/permissions', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}
